export const GetFileExtension = (fileName: string): string =>
  fileName.slice(fileName.lastIndexOf("."))?.toLowerCase() ?? "";
